<template>
    <section
        :id="id"
        class="mb-12">

        <v-btn
            v-show="leftArrow"
            elevation="2"
            absolute
            left
            fab
            @click.stop="scrollLeft(id)">
            <v-icon size="48">mdi-chevron-left</v-icon>
        </v-btn>

        <div class="section-wrapper">
            <h1
                class="white--text"
                v-text="title" />

            <div
                :class="scrollable ? 'scrollable' : ''"
                class="d-flex carousel-wrapper">
                <competences-element
                    v-for="element in elements"
                    :key="element.name"
                    :element="element"/>
            </div>
        </div>

        <v-btn
            v-show="rightArrow"
            elevation="2"
            absolute
            right
            fab
            @click.stop="scrollRight(id)">
            <v-icon size="48">mdi-chevron-right</v-icon>
        </v-btn>
    </section>
</template>

<script>
import CompetencesElement from './competencesElement'

export default {
    name: 'competencesElements',
    components: {
        CompetencesElement
    },
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        elements: {
            type: Array,
            required: true
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.initEvents(this.id)
        })
    }
}
</script>

<style scoped lang="scss">
section {
    position: relative !important;

    .section-wrapper {
        overflow: hidden !important;
        height: max-content !important;

        .carousel-wrapper {
            margin-bottom: -17px !important;
            overflow-y: auto !important;

            &:not(.scrollable) {
                margin-bottom: 0 !important;
            }
        }
    }

    > .v-btn {
        top: calc(50% - 14px) !important;

        &--left {
            left: -36px !important;
        }

        &--right {
            right: -36px !important;
        }
    }
}

@media (max-width: 960px) {
    section .section-wrapper .carousel-wrapper {
        margin-bottom: 0px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/competences/competencesElements.vue